import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12","key":"svg-0"}],["path",{"d":"M4 12h8","key":"svg-1"}],["path",{"d":"M12 15h8","key":"svg-2"}],["path",{"d":"M12 9h8","key":"svg-3"}],["path",{"d":"M12 4v16","key":"svg-4"}]]

const IconLayoutBoardSplit = createReactComponent('outline', 'layout-board-split', 'LayoutBoardSplit', __iconNode);

export default IconLayoutBoardSplit;